import { COMPANYFLAG_LOOKUP_QUERY } from '../queries.js';

async function checkCompanyTable(company) {
    try {
      const response = await fetch('/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: COMPANYFLAG_LOOKUP_QUERY.loc.source.body,
          variables: {
            company: company,
          },
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('Failed to fetch data: ', error);
    }
  }
export default checkCompanyTable;